import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import CasesPage from "./pages/CasesPage";
import BlogPage from "./pages/BlogPage";
import BookLandingPage from "./pages/BookLandingPage";
import BookSelectTimePage from "./pages/BookSelectTimePage";
import BookIntakePage from "./pages/BookIntakePage";
import BookConfirmPage from "./pages/BookConfirmPage";
import LoginPage from "./pages/LoginPage";
import AccountPage from "./pages/AccountPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminCalendarPage from "./pages/admin/AdminCalendarPage";
import AdminAppointmentsPage from "./pages/admin/AdminAppointmentsPage";
import AdminAppointmentDetailPage from "./pages/admin/AdminAppointmentDetailPage";
import AdminClientsPage from "./pages/admin/AdminClientsPage";
import AdminClientDetailPage from "./pages/admin/AdminClientDetailPage";
import AdminTypesPage from "./pages/admin/AdminTypesPage";
import AdminAvailabilityPage from "./pages/admin/AdminAvailabilityPage";
import AdminSettingsPage from "./pages/admin/AdminSettingsPage";
import AdminDocumentsPage from "./pages/admin/AdminDocumentsPage";
import AdminMemberWorkspacePage from "./pages/admin/AdminMemberWorkspacePage";
import AdminDocumentDetailPage from "./pages/admin/AdminDocumentDetailPage";
import AdminAuditLogPage from "./pages/admin/AdminAuditLogPage";
import AdminAssignmentsPage from "./pages/admin/AdminAssignmentsPage";
import AdminCategoriesPage from "./pages/admin/AdminCategoriesPage";
import AdminTaxSpecialistsPage from "./pages/admin/AdminTaxSpecialistsPage";
import SpecialistSettingsPage from "./pages/admin/SpecialistSettingsPage";
import AdminDropboxPage from "./pages/admin/AdminDropboxPage";
import AdminEmailsPage from "./pages/admin/AdminEmailsPage";
import AdminLeadsPage from "./pages/admin/AdminLeadsPage";
import AdminSpecialistApplicationsPage from "./pages/admin/AdminSpecialistApplicationsPage";
import SpecialistMemberRequestsPage from "./pages/admin/SpecialistMemberRequestsPage";
import AdminTurnstilePage from "./pages/admin/AdminTurnstilePage";
import AdminWorkflowStagesPage from "./pages/admin/AdminWorkflowStagesPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import VerifyCodePage from "./pages/VerifyCodePage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SpecialistApplyPage from "./pages/SpecialistApplyPage";
import SpecialistsDirectoryPage from "./pages/SpecialistsDirectoryPage";
import SpecialistPublicProfilePage from "./pages/SpecialistPublicProfilePage";
import MemberDocumentsPage from "./pages/member/MemberDocumentsPage";
import MemberUploadPage from "./pages/member/MemberUploadPage";
import MemberDocumentDetailPage from "./pages/member/MemberDocumentDetailPage";
import MemberTaxFilePage from "./pages/member/MemberTaxFilePage";
import MemberNotificationsPage from "./pages/MemberNotificationsPage";
import MemberSpecialistPage from "./pages/MemberSpecialistPage";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./lib/auth";
import LanguageSync from "./context/LanguageSync";
import RequireAuth from "./lib/RequireAuth";
import LoginGate from "./lib/LoginGate";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <LanguageSync>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/cases" element={<CasesPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/contact" element={<ContactPage />} />

              {/* Unified auth */}
              <Route path="/login" element={<LoginPage defaultMode="login" />} />
              <Route path="/signup" element={<LoginPage defaultMode="signup" />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/verify-code" element={<VerifyCodePage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />

              {/* Member dashboard */}
              <Route path="/account" element={<LoginGate><AccountPage /></LoginGate>} />
              <Route path="/account/documents" element={<LoginGate><MemberDocumentsPage /></LoginGate>} />
              <Route path="/account/documents/upload" element={<LoginGate><MemberUploadPage /></LoginGate>} />
              <Route path="/account/documents/:id" element={<LoginGate><MemberDocumentDetailPage /></LoginGate>} />
              <Route path="/account/tax-file" element={<LoginGate><MemberTaxFilePage /></LoginGate>} />
              <Route path="/account/notifications" element={<LoginGate><MemberNotificationsPage /></LoginGate>} />
              <Route path="/account/specialist" element={<LoginGate><MemberSpecialistPage /></LoginGate>} />

              {/* Booking flow (gated) */}
              <Route path="/book" element={<LoginGate><BookLandingPage /></LoginGate>} />
              <Route path="/book/confirm/:token" element={<BookConfirmPage mode="confirm" />} />
              <Route path="/book/manage/:token" element={<BookConfirmPage mode="manage" />} />
              <Route path="/book/:typeId" element={<LoginGate><BookSelectTimePage /></LoginGate>} />
              <Route path="/book/:typeId/details" element={<LoginGate><BookIntakePage /></LoginGate>} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<RequireAuth><AdminDashboard /></RequireAuth>} />
              <Route path="/admin/calendar" element={<RequireAuth><AdminCalendarPage /></RequireAuth>} />
              <Route path="/admin/appointments" element={<RequireAuth><AdminAppointmentsPage /></RequireAuth>} />
              <Route path="/admin/appointments/:id" element={<RequireAuth><AdminAppointmentDetailPage /></RequireAuth>} />
              <Route path="/admin/clients" element={<RequireAuth><AdminClientsPage /></RequireAuth>} />
              <Route path="/admin/clients/:id" element={<RequireAuth><AdminClientDetailPage /></RequireAuth>} />
              <Route path="/admin/types" element={<RequireAuth role="admin"><AdminTypesPage /></RequireAuth>} />
              <Route path="/admin/availability" element={<RequireAuth><AdminAvailabilityPage /></RequireAuth>} />
              <Route path="/admin/settings" element={<RequireAuth role="admin"><AdminSettingsPage /></RequireAuth>} />
              <Route path="/admin/documents" element={<RequireAuth><AdminDocumentsPage /></RequireAuth>} />
              <Route path="/admin/documents/:id" element={<RequireAuth><AdminDocumentDetailPage /></RequireAuth>} />
              <Route path="/admin/members/:id/tax-file" element={<RequireAuth><AdminMemberWorkspacePage /></RequireAuth>} />
              <Route path="/admin/audit-log" element={<RequireAuth role="admin"><AdminAuditLogPage /></RequireAuth>} />
              <Route path="/admin/assignments" element={<RequireAuth role="admin"><AdminAssignmentsPage /></RequireAuth>} />
              <Route path="/admin/document-categories" element={<RequireAuth role="admin"><AdminCategoriesPage /></RequireAuth>} />
              <Route path="/admin/tax-specialists" element={<RequireAuth role="admin"><AdminTaxSpecialistsPage /></RequireAuth>} />
              <Route path="/admin/me" element={<RequireAuth><SpecialistSettingsPage /></RequireAuth>} />
              <Route path="/admin/dropbox" element={<RequireAuth role="admin"><AdminDropboxPage /></RequireAuth>} />
              <Route path="/admin/emails" element={<RequireAuth role="admin"><AdminEmailsPage /></RequireAuth>} />
              <Route path="/admin/leads" element={<RequireAuth role="admin"><AdminLeadsPage /></RequireAuth>} />
              <Route path="/admin/specialist-applications" element={<RequireAuth role="admin"><AdminSpecialistApplicationsPage /></RequireAuth>} />
              <Route path="/admin/member-requests" element={<RequireAuth><SpecialistMemberRequestsPage /></RequireAuth>} />
              <Route path="/admin/turnstile" element={<RequireAuth role="admin"><AdminTurnstilePage /></RequireAuth>} />
              <Route path="/admin/workflow-stages" element={<RequireAuth role="admin"><AdminWorkflowStagesPage /></RequireAuth>} />
              <Route path="/apply/specialist" element={<SpecialistApplyPage />} />
              <Route path="/specialists" element={<SpecialistsDirectoryPage />} />
              <Route path="/specialists/:slug" element={<SpecialistPublicProfilePage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
          </LanguageSync>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
